<template src='./index.html'></template>
<script>
import { getdata } from './data.js';
import czzzq from './czzzq/index.vue';

export default {
    name: 'ywlxgz',
    components: {
        czzzq, // 操作著作权弹框
    },
    data: function() {
        return {
            tablekey: 0,
            overlength: 0,
            searchdata: getdata().searchdata,
            searchlist: getdata().searchlist,
            filterSearchlist: [],
            headData: getdata().headData,
            pagination: getdata().pagination,
            tableData: [{}],
            searchdiag: false,
            formdata: {},
            zzqdialog: false,
            wikiType: "",
            zzqTitle: ""
        };
    },
    mounted() {
    },
    created() {
        this.init();
    },
    methods: {
        geOoverLength(e) {
            this.overlength = e;
        },
        create() {
            // 新建
            this.zzqdialog = true;
            this.zzqTitle = "新建著作权";
            this.wikiType = "0";
        },
        exportData() {
            // 导出
        },
        deleteData() {
            // 删除
        },
        init() {
            //初始化
        },
        view(e) {
            // 查看
        },
        edit(e) {
            // 编辑
            this.zzqdialog = true;
            this.zzqTitle = "编辑著作权";
            this.wikiType = "0";
        },
        sizechange(e) {
            this.pagination.pageSize = e;
        },
        currentChange(e) {
            this.pagination.pageNum = e;
        },
        submitSearch() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
        },
        forRefresh() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
        },
        forUpdateSearch() {
            this.filterSearchlist = JSON.parse(JSON.stringify(this.filterSearchlist.length ? this.filterSearchlist : this.searchlist));
            this.searchdiag = true;
        },
        closeSearch() {
            this.searchdiag = false;
        },
        saveChange(e) {
            this.filterSearchlist = e;
            this.searchlist = e.filter(item => item.isshow);
            this.searchdiag = false;
        },
        confirmfilter(e) {
            this.headData = e.chooselist;
            this.outlist = e.nochooselist;
        },
        forback() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
        },
        closediag() {
            this.zzqdialog = false;
        }
    }
};
</script>

<style scoped lang='less'>
@import url('./index.less');
</style>
